/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect, useState} from 'react';
import {validatePhoneNumberLength, parsePhoneNumberFromString as parsePhoneNumber} from "libphonenumber-js";
import axios from 'axios';
import moment from "moment-timezone";
import {useSelector, useDispatch} from 'react-redux';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import * as action from '../actions';
import {Modal, Button} from 'react-bootstrap';
import BackIcon from '../assets/SVG/buttons/back-button.svg';
import config from '../config';
import Profile from '../assets/SVG/icons/Avatar.svg';
import Close from '../assets/SVG/buttons/close-icon.svg';
import Edit from '../assets/SVG/icons/edit.svg';
import ErrorIcon from '../assets/SVG/icons/error-icon.svg';
import EyeIconOn from '../assets/SVG/icons/eye-icon-active.svg';
import EyeIconOff from '../assets/SVG/icons/eye-icon.svg';
import {countryData} from '../utils/country.data';
import '../styles/updateprofile.css';
import {useHistory} from "react-router-dom";
import useToastify from "../hooks/useToastify";
import useTitle from "../hooks/useTitle";
import useFileHelper from "../hooks/useFileHelper";
import useModal from '../hooks/useModal';

axios.defaults.withCredentials = true;

export default function UpdateProfile() {
  useTitle("Update Profile");

  const history = useHistory();
  const dispatch = useDispatch();
  const {notifyError, notifySuccess} = useToastify();
  const {isFileSizeValid, isValidPicture} = useFileHelper();

  const [isLoading, setIsLoading] = useState(false);
  const [pic, setPic] = useState();
  const [user, setUser] = useState(useSelector(state => state.user));
  const [view, setView] = useState(false);
  const [phoneCountry, setPhoneCountry] = useState(null);
  const [phoneNumberError, setPhoneNumberError] = useState("");
  const [state, setState] = useState({
    email: "",
    password: "",
    confirmPassword: "",
    showPassword: false,
    showConfirmPassword: false,
    fname: user.firstName,
    lname: user.lastName,
    phoneNumber: {
      code: user.phoneNumber?.code ?? "",
      number: user.phoneNumber?.number ?? "",
    },
    gender: "",
    dob: "",
    picture: "",
    errMsgPass: "",
    isPassInvalid: false,
    errorMsg: "",
    successMsg: "",
    fileErr: "",
    street: user?.address?.street || '',
    stateProvince: user?.address?.stateProvince || '',
    country: user?.address?.country || '',
    isPhoneNumberNull: false,
    isStreetNull: false,
    isCountryNull: false,
    stateProvinceNull: false,
  });

  const {isModalOpen, openModal, closeModal} = useModal();
  const handleShowModal = () => openModal();
  const handleCloseModal = () => {
    closeModal();
    setPic(null);
    setState(prevState => ({
      ...prevState,
      fileErr: ""
    }));
  };

  const handleShowWarning = () => setView(true);
  const handleCloseWarning = () => setView(false);

  const getUser = () => {
    setIsLoading(true);

    axios.get(config.backend_url + '/userdetails')
      .then((response) => {
        setIsLoading(false);

        setState(prevState => ({
          ...prevState,
          fname: response.data.userInfo.firstName,
          lname: response.data.userInfo.lastName,
          phoneNumber: {
            code: response.data.userInfo.phoneNumber?.code ?? "",
            number: response.data.userInfo.phoneNumber?.number ?? "",
          },
          email: response.data.userInfo.email,
          gender: response.data.userDetails.gender,
          dob: response.data.userDetails.dob ? moment.utc(response.data.userDetails.dob).format('yyyy-MM-DD') : "",
          picture: response.data.userInfo.picture,
          stateProvince: response.data.userInfo.address?.stateProvince || '',
          country: response.data.userInfo.address?.country || '',
        }));
      })
      .catch((error) => {
        handleError(error);
        const status = error?.status ?? error?.response?.status;
        if (status === 401) {
          history.push('/login');
        }
      })
  };
  useEffect(() => {
    getUser();
  }, []);

  const handleChange = (e) => {
    const {id, value} = e.target;
    setState(prevState => ({
      ...prevState,
      [id]: value
    }));
  };

  const handleError = (error) => {
    setIsLoading(false);
    console.log('error', error);
    const message = error?.response?.data?.message ?? "Error Occurred!";
    notifyError(message);
    setState(prevState => ({
      ...prevState,
      errorMsg: message,
    }));
  }

  const toggleShowPassword = (e) => {
    setState(prevState => ({
      ...prevState,
      showPassword: !state.showPassword
    }));
  }

  const toggleShowConfirmPassword = (e) => {
    setState(prevState => ({
      ...prevState,
      showConfirmPassword: !state.showConfirmPassword
    }));
  }

  const handleProfile = (e) => {
    setPic(e.target.files[0]);
    setState(prevState => ({
      ...prevState,
      fileErr: ""
    }));
  };

  const handleUploadPic = () => {
    if (!isValidPicture(pic)) {
      return setState(prevState => ({
        ...prevState,
        fileErr: "Only .jpeg and .png files are supported."
      }));
    }

    if (!isFileSizeValid(pic)) {
      return setState(prevState => ({
        ...prevState,
        fileErr: "File Size should not be more than 1 MB."
      }));
    }

    setIsLoading(true);
    setState(prevState => ({
      ...prevState,
      successMsg: "",
      errorMsg: ""
    }));

    const formData = new FormData();
    formData.append("image", pic);
    formData.append("picture", state.picture);

    axios.put(config.backend_url + '/useroperations', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
      .then((response) => {
        setIsLoading(false);
        setState(prevState => ({
          ...prevState,
          picture: response.data.userInfo.picture
        }));

        setUser(response.data.userInfo);
        dispatch(action.updateUser(response.data.userInfo));

        handleCloseModal();
        notifySuccess(response.data.message);
      })
      .catch((error) => {
        handleError(error);
      });
  };

  const handleDeletePic = () => {
    setIsLoading(true);
    setState(prevState => ({
      ...prevState,
      successMsg: "",
      errorMsg: ""
    }));

    axios.delete(config.backend_url + '/useroperations', {data: {picture: state.picture}})
      .then((response) => {
        setIsLoading(false);

        setUser(response.data.userInfo);
        dispatch(action.updateUser(response.data.userInfo));

        setState(prevState => ({
          ...prevState,
          picture: response.data.userInfo.picture,
        }));

        handleCloseModal();
        notifySuccess(response.data.message);
      })
      .catch((error) => {
        handleError(error);
      })
  };

  const handleDeleteProfile = () => {
    setView(false);

    //making delete req
    axios.delete(config.backend_url + '/useroperations/user/')
      .then((res) => {
        // Clear user state
        dispatch(action.logoutUser);
        history.push('/login');
        // window.location.replace("/login");
      })
      .catch((error) => {
        handleError(error);
      })
  }

  const handlePhoneChange = (value, country) => {
    setPhoneCountry(country);
    const dialCode = country.dialCode;
    setState(prevState => ({
      ...prevState,
      phoneNumber: {
        code: "+" + dialCode,
        number: value.slice(dialCode.length),
      }
    }));
  };

  useEffect(() => {
    if (state.phoneNumber.code && state.phoneNumber.number && phoneCountry) {
      const countryCode = phoneCountry?.countryCode?.toUpperCase();
      const number = state.phoneNumber.code + state.phoneNumber.number;
      const phoneNumber = parsePhoneNumber(number, countryCode);
      const validateLength = validatePhoneNumberLength(number, countryCode);
      if (phoneNumber && phoneNumber.isValid()) {
        setPhoneNumberError("");
      } else {
        if (validateLength === "TOO_LONG") {
          setPhoneNumberError("The entered number is too long");
        } else if (validateLength === "TOO_SHORT") {
          setPhoneNumberError("The entered number is too short");
        } else {
          setPhoneNumberError("The entered number is invalid");
        }
      }
    }
  }, [state.phoneNumber.number]);

  const handleSubmitClick = (e) => {
    e.preventDefault();

    setState(prevState => ({
      ...prevState,
      errMsgPass: "",
      isPassInvalid: false,
      successMsg: "",
      errorMsg: "",
      isPhoneNumberNull: false,
      isStreetNull: false,
      isCountryNull: false,
      stateProvinceNull: false,
    }));
    if (!state.stateProvince) {
      return setState(prevState => ({
        ...prevState,
        stateProvinceNull: true
      }));
    }
    if (!state.phoneNumber.number) {
      return setState(prevState => ({
        ...prevState,
        isPhoneNumberNull: true
      }));
    }
    if (phoneNumberError) {
      return;
    }
    if (!state.country) {
      return setState(prevState => ({
        ...prevState,
        isCountryNull: true
      }));
    }

    if (!!state.password && !isValidPassword(state.password)) {
      return setState(prevState => ({
        ...prevState,
        isPassInvalid: true
      }));
    }

    if (state.password !== state.confirmPassword) {
      return setState(prevState => ({
        ...prevState,
        errMsgPass: " Passwords don't match"
      }));
    }

    return sendDetailsToServer();
  };

  const isValidPassword = (text) => {
    let re = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[ !"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]).{8,}$/;
    return text.match(re);
  };

  const sendDetailsToServer = () => {
    setIsLoading(true);

    const payload = {
      pw: state.password,
      firstName: state.fname,
      lastName: state.lname,
      phoneNumber: state.phoneNumber,
      gender: state.gender,
      dob: state.dob,
      picture: state.picture,
      address: {
        // street: state.street,
        stateProvince: state.stateProvince,
        country: state.country,
      }
    };

    axios.put(config.backend_url + '/userDetails', payload)
      .then(function (response) {
        setIsLoading(false);
        //profile updated successfully
        setState(prevState => ({
          ...prevState,
          successMsg: response.data.message,
          fname: response.data.userInfo.firstName,
          lname: response.data.userInfo.lastName,
          phoneNumber: {
            code: response.data.userInfo.phoneNumber?.code ?? "",
            number: response.data.userInfo.phoneNumber?.number ?? "",
          },
          gender: response.data.userDetails.gender,
          dob: response.data.userDetails.dob ? moment.utc(response.data.userDetails.dob).format('yyyy-MM-DD') : "",
        }));

        setUser(response.data.userInfo);
        dispatch(action.updateUser(response.data.userInfo));

        notifySuccess(response.data.message);
      })
      .catch(function (error) {
        handleError(error);
      });
  };

  return (
    <div className="container" data-testid="update-profile-page">
      <div className="main update-form" data-testid="update-form">
        {isLoading && <div id="loading-spin"></div>}
        <div className="mt-3 header">
          <img src={BackIcon} alt='covid-test' onClick={history.goBack}/>
          <p className='heading'>Profile</p>
          <span className='dummy'></span>
        </div>

        <div className='profile-wrapper'>
          <img src={state.picture ? state.picture : user.picture ? user.picture : Profile} alt="profile"
               className="profile" onClick={handleShowModal}></img>
          <div className="edit-link mt-2">
            <button onClick={handleShowModal}>Edit picture <img src={Edit} alt="edit"/></button>
          </div>
        </div>

        <div className='wrapper mt-1'>
          <div className='flex-row'>
            <div className='wrapper-small'>
              <div className="email">
                <span className='gray-color'> Email ID:</span>
                <p className='font-size-18 ml-2'>{state.email}</p>
              </div>
            </div>
            <div className='wrapper-small'>
              <div className='flex-row'>
                <div className="form-group">
                  <div className='flex-col'>
                    <label className="label">New Password</label>
                    <div className="input-box">
                      <input type={state.showPassword ? "text" : "password"} id="password"
                             className={"form-control " + (state.password ? "navy-text " : "") + (state.isPassInvalid ? "red-border " : "")}
                             placeholder="New Password" value={state.password} onChange={handleChange}/>
                      <img src={state.showPassword ? EyeIconOn : EyeIconOff} alt="password icon" className='pointer'
                           onClick={toggleShowPassword}/>
                    </div>
                    {state.isPassInvalid &&
                      <><p><img src={ErrorIcon} alt="passInvalid"/> Password should contain:</p>
                        <ul>
                          <li>At least 1 uppercase character</li>
                          <li>At least 1 lowercase character</li>
                          <li>At least 1 numeric character</li>
                          <li>At least 1 special character</li>
                          <li>Length must be at least 8 characters</li>
                        </ul>
                      </>}
                  </div>
                </div>

                <div className="form-group">
                  <div className='flex-col'>
                    <label className="label">Confirm New Password</label>
                    <div className="input-box">
                      <input type={state.showConfirmPassword ? "text" : "password"} id="confirmPassword"
                             className={"form-control " + (state.confirmPassword ? "navy-text " : "") + (state.errMsgPass ? "red-border " : "")}
                             placeholder="Confirm Password" value={state.confirmPassword} onChange={handleChange}/>
                      <img src={state.showConfirmPassword ? EyeIconOn : EyeIconOff} alt="confirm password icon"
                           className='pointer' onClick={toggleShowConfirmPassword}/>
                    </div>
                    {state.errMsgPass && <p><img src={ErrorIcon} alt="errMsgPass"/>{state.errMsgPass}</p>}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className='flex-row'>
            <div className='wrapper-small'>
              <div className='flex-row'>
                <div className="form-group">
                  <label className="label">First Name *</label>
                  <input type="text" id="fname" className={"form-control " + (state.fname ? "navy-text" : "")}
                         placeholder="First Name" value={state.fname}
                         onChange={handleChange}/>
                </div>

                <div className="form-group">
                  <label className="label">Last Name *</label>
                  <input type="text" id="lname" className={"form-control " + (state.lname ? "navy-text" : "")}
                         placeholder="Last Name" value={state.lname} onChange={handleChange}/>
                </div>
              </div>
            </div>

            <div className='wrapper-small'>
              <div className='flex-row'>
                <div className="form-group">
                  <label className="label">Date of Birth</label>
                  <input type="date" id="dob" className={"form-control " + (state.dob ? "navy-text" : "")}
                         placeholder="DOB" value={state.dob} onChange={handleChange}/>
                </div>

                <div className="form-group">
                  <label className="label">Gender</label><br/>
                  <select id="gender"
                          className={"form-control " + (!(state.gender === "Not Selected" || !state.gender) ? "navy-text" : "")}
                          value={state.gender} onChange={handleChange}>
                    <option value="Not Selected">Not Selected</option>
                    <option value="Female">Female</option>
                    <option value="Male">Male</option>
                    <option value="Other">Other</option>
                    <option value="Prefer not to answer">Prefer not to answer</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div className='flex-row address-row'>
            <div className='province-country'>
              <div className="form-group state-province">
                <label className="label">Phone Number *</label>
                <PhoneInput
                  data-testid="phoneNumber"
                  id="phoneNumber"
                  inputClass={"form-control " + (state.phoneNumber.number ? "navy-text " : "") + (state.isPhoneNumberNull ? "red-border " : "")}
                  buttonClass={(state.phoneNumber.number ? "navy-text " : "") + (state.isPhoneNumberNull ? "red-border " : "")}
                  inputProps={{
                    name: 'phoneNumber',
                    "data-testid": "phoneNumber",
                    id: 'phoneNumber',
                    required: true
                  }}
                  country={'ca'}
                  value={state.phoneNumber.code + state.phoneNumber.number}
                  onChange={handlePhoneChange}
                  required
                />
                {phoneNumberError &&
                  <p data-testid="isPhoneNumberError"><img src={ErrorIcon} alt="phoneNumberError"/>{phoneNumberError}</p>
                }
                {state.isPhoneNumberNull &&
                  <p data-testid="isPhoneNumberNull"><img src={ErrorIcon} alt="phoneNumberNull"/>Phone Number is
                    Required!</p>
                }
              </div>
              <div className="form-group state-province">
                <label className="label">Province/State *</label>
                <input alt="stateProvince" data-testid="stateProvince" type="text" id="stateProvince"
                       className={"form-control " + (state.stateProvince ? "navy-text " : "") + (state.stateProvinceNull ? "red-border " : "")}
                       placeholder="Ontario" value={state.stateProvince} onChange={handleChange} required/>
                {state.stateProvinceNull &&
                  <p alt="stateProvinceNull" data-testid="stateProvinceNull">
                    <img src={ErrorIcon} alt="stateProvinceNull"/>Province/State is Required!</p>
                }
              </div>
              <div className="form-group select-country">
                <label className="label">Country *</label>
                <select id="country" name="country" className="custom-select" onChange={handleChange}>
                  <option selected disabled={state.country}>Country</option>
                  {countryData.map((country, index) => <option key={index} selected={state.country === country.label}
                                                               value={country.label}>{country.label}</option>)}
                </select>
                {state.isCountryNull &&
                  <p alt="isCountryNull" data-testid="isCountryNull"><
                    img src={ErrorIcon} alt="isCountryNull"/>
                    Country is Required!
                  </p>
                }
              </div>
            </div>
          </div>
        </div>

        <div className="btn-submit mt-3">
          <Button className="btn save" onClick={handleSubmitClick}>Save</Button>
          <Button id='deleteAccount' className="btn delete" onClick={handleShowWarning}>Delete Account</Button>
        </div>

        <Modal animation={false} show={isModalOpen} onHide={handleCloseModal} centered className="special_modal">
          <Modal.Body className="header">
            <img src={Close} alt="close" onClick={handleCloseModal}/>
          </Modal.Body>
          <Modal.Body className="body">
            <img src={state.picture ? state.picture : user.picture ? user.picture : Profile} alt="profile"
                 className="profile"/>
            <p>Recommended Size: 512x512 pixels<br/>
              Maximum file size: 1 MB<br/>
              Only .jpeg and .png files are supported.
            </p>
          </Modal.Body>
          <div className="file-upload">
            <input type='file' id="fileinput" onChange={handleProfile}></input>
            {state.fileErr && <p id='fileErr'>{state.fileErr}</p>}
          </div>
          <Modal.Body className="body">
            {pic ? <Button className="btn-upload" onClick={handleUploadPic}>Upload Picture</Button>
              : <Button className="btn-upload" disabled>Upload Picture</Button>}
            {state.picture ? <Button className="btn-delete" onClick={handleDeletePic}>Delete Picture</Button>
              : <Button className="btn-delete" disabled>Delete Picture</Button>}
          </Modal.Body>
        </Modal>

        <Modal animation={false} show={view} onHide={handleCloseWarning} centered className='warning_modal'>
          <Modal.Body>
            <p>Are you sure you want to delete your account?</p>
          </Modal.Body>
          <Modal.Footer>
            <Button id='cancelDelete' variant='secondary' onClick={handleCloseWarning}>No</Button>
            <Button id='btn-delete-profile' className='primary' onClick={handleDeleteProfile}>Yes</Button>
          </Modal.Footer>
        </Modal>
      </div>
    </div>
  )
}
